import { render, staticRenderFns } from "./Article_edit.vue?vue&type=template&id=927346e8&scoped=true&"
import script from "./Article_edit.vue?vue&type=script&lang=js&"
export * from "./Article_edit.vue?vue&type=script&lang=js&"
import style0 from "./Article_edit.vue?vue&type=style&index=0&id=927346e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927346e8",
  null
  
)

export default component.exports